//when dom ready,no jquery
document.addEventListener('DOMContentLoaded', function () {
    // typeof guards (2026-06-12): collection.js is now loaded site-wide from
    // layout/theme.liquid (card quick-add / Notify Me delegates needed on
    // search + homepage featured cards too). sectionId / productId are inline
    // globals that only exist on collection / product templates - a bare
    // reference would throw ReferenceError elsewhere and kill this handler.
    var _sectionId = (typeof sectionId !== 'undefined') ? sectionId : null
    var _productId = (typeof productId !== 'undefined') ? productId : null
    if (_sectionId) {
        // Pipeline B retired (PR III, 2026-05-10): no more art-template render via Go service
    }
    backInstock()
    if (_productId) {
        fetchSubscribeCount(_productId)
    }
    hidePastArrivalMonths()
    new MutationObserver(hidePastArrivalMonths).observe(document.body, { childList: true, subtree: true })
});
// ARRIVAL MONTH filter (Bin 2026-10-01): snippets/facets.liquid drops months before the
// current one, but a cached page can still carry last month's 'now' after the 1st. Hide
// unselected past months again by the shop's clock (America/Los_Angeles).
function hidePastArrivalMonths() {
    var lists = document.querySelectorAll('[data-arrival-months-filter]')
    if (!lists.length) {
        return
    }
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit' })
        .formatToParts(new Date())
    var get = function (type) { return parts.filter(function (p) { return p.type === type })[0].value }
    var currentMonth = get('year') + '-' + get('month')
    lists.forEach(function (list) {
        list.querySelectorAll('input[name="filter.p.m.custom.arrival_months"]').forEach(function (input) {
            var row = input.closest('.checkbox-control')
            if (row && !input.checked && input.value < currentMonth && row.style.display !== 'none') {
                row.style.display = 'none'
            }
        })
    })
}
const w = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800]
function fetchSubscribeCount(productId) {
    // Bin 2026-06-28: show subscriber count on in-stock PDP too (social proof,
    // like wishlist/reviews). Previously gated on #subscribe-button which only
    // renders on OOS/pre-order pages. Now only require a #subscribe-data target;
    // buy-buttons.liquid renders that container on in-stock pages as well.
    if (!productId) {
        return
    }
    var subscribeDataEle = document.getElementById('subscribe-data')
    if (!subscribeDataEle) {
        return
    }
    let url = "https://app.prexhobby.com/product/subscribe-count/"+productId
    fetch(url, { method: 'GET' }).then(response => response.json()).then(data => {
        if (data.data){
            const existingCount = document.getElementById('subscribe-count')
            if (existingCount) {
                existingCount.remove()
            }
            const countSpan = document.createElement('span')
            countSpan.className = 'text-xs'
            countSpan.id = 'subscribe-count'
            // Bin 2026-10-23: Trading Cards hide the count below 10 (data-min-count
            // from buy-buttons.liquid). Below the threshold the span stays empty and is
            // marked moved so product-info.liquid moveSubscribeCount() stops waiting.
            var minCount = Number(subscribeDataEle.dataset.minCount) || 1
            if (Number(data.data) < minCount) {
                countSpan.dataset.prexMoved = '1'
                countSpan.style.display = 'none'
            } else if(data.data >0){
                // 2026-10-12: singular for a count of 1
                countSpan.textContent = `${data.data} ${Number(data.data) === 1 ? 'subscriber' : 'subscribers'}`
            }else{
                countSpan.textContent = ''
            }
            subscribeDataEle.appendChild(countSpan)
        }
    })
        
}

// ============================================================================
// Pipeline B retirement (PR III, 2026-05-10):
//   Removed: fetchProductsHtml, fetchSectionHtml, syncSortFromUrl, changeFilter,
//   updateCollectionBarToggles, applyCollectionToggleState, getPagination,
//   getFilterRemoveUrl, getPaginationUrl
//   These functions powered the Go-service-fetched, art-template-rendered
//   collection grid (Pipeline B). Pipeline A (Liquid server-side product-card
//   rendering, see sections/main-collection-custom.liquid line ~349) is now
//   the sole rendering path. Go endpoint app.prexhobby.com/product/query-by-collection
//   to be shut down by Train after a 3-day stable monitoring period.
// ============================================================================


function backInstock() {
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('.back-instock')
        const closeBtn = e.target.closest('#back-instock-close')
        const gSubscribeBtn = e.target.closest('#gSubscribeBtn')
        if (btn) {
            const str = btn.getAttribute('data-product') || "{}"
            const product = JSON.parse(str)
            
            product.title =btn.getAttribute('data-title') || ""
            product.productPrice=product.price
            // French edition (2026-10-15): the popup asks for the French-edition tick before subscribing.
            product.french = btn.getAttribute('data-french') === '1'
            // SMS opt-in (MKT-1017-1221): data-sms comes from snippets/bis-sms-eligible.liquid.
            product.sms = btn.getAttribute('data-sms') === '1'

            const html = template('back-instock', product)
            document.body.insertAdjacentHTML('beforeend', html)
        }

        if (closeBtn) {
            const modal = document.getElementById('Globo-Back-In-Stock-Popup')
            modal.remove()
        }
        if (gSubscribeBtn) {
            handleSubmitBis()
        }
    })
}
function handleSubmitBis() {
    const gSubscribeBtn = document.getElementById('gSubscribeBtn')
    const emailEle = document.getElementById('gBackInStock-Form-Product-Email')
    const productId = document.getElementById('gBackInStock-Form-Product-Id').value
    const variantId = document.getElementById('gBackInStock-Form-Variant-Id').value
    const formData = new FormData()
    const data = {}
    data['shop'] = 'aot-supply.myshopify.com'
    data['locale'] = 'en'
    data['notification'] = 'email'
    data['content[keyLabel]'] = '{}'
    data['email'] = emailEle.value
    data['productId'] = productId
    data['variant_id'] = variantId
    const formControl = emailEle.parentElement

    // French edition (2026-10-15): no subscription without the tick.
    const frAck = document.getElementById('prex-fr-ack-popup')
    if (frAck) {
        const frControl = frAck.closest('.gBackInStock-Form-Control')
        const frMsg = frControl.querySelector('.gBackInStock-messages')
        if (!frAck.checked) {
            frControl.classList.add('has-error')
            frMsg.classList.add('gBackInStock-messages-error')
            frMsg.innerHTML = 'Please confirm you want the French edition. / Veuillez confirmer l&rsquo;édition française.'
            frAck.focus()
            return
        }
        frControl.classList.remove('has-error')
        frMsg.classList.remove('gBackInStock-messages-error')
        frMsg.innerHTML = ''
    }

    //验证email 
    if (!validateEmail(emailEle.value)) {
        formControl.classList.add('has-error')
        const msgEle = formControl.querySelector('.gBackInStock-messages')
        msgEle.classList.add('gBackInStock-messages-error')
        msgEle.innerHTML = 'The email address you entered is invalid'
        emailEle.focus()
        return
    } else {
        formControl.classList.remove('has-error')
        const msgEle = formControl.querySelector('.gBackInStock-messages')
        msgEle.classList.remove('gBackInStock-messages-error')
        msgEle.innerHTML = ''
    }
   
    // Optional SMS opt-in (MKT-1017-1221): only number + ticked box goes to Klaviyo.
    const smsPhone = readSmsOptIn()
    if (smsPhone === false) {
        return
    }

    gSubscribeBtn.classList.add('button--loading')
    if (smsPhone) {
        subscribeSms(emailEle.value, smsPhone)
    }
    // let url = "http://127.0.0.1:9090/subscribe/create"
    let url = "https://app.prexhobby.com/subscribe/create"
    
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(response => response.json()).then(data => {
        let html = ""
        if (data.code == 0) {
            html = `<div class="gBackInStock-Form-Message">
            <p class="gBackInStock-Message gBackInStock-Message-Success">${data.data}</p>
        </div>`

        } else {
            html = `<div class="gBackInStock-Form-Message">
            <p class="gBackInStock-Message gBackInStock-Message-Error">${data.msg}</p>
        </div>`
        }
        const ele = document.getElementById('Globo-Back-In-Stock-Popup').querySelector('.Globo-body-footer')
        const msg = ele.querySelector('.gBackInStock-Form-Message')
        if (msg) {
            msg.remove()
        }
        ele.insertAdjacentHTML('beforeend', html)
    }).finally(() => {
        gSubscribeBtn.classList.remove('button--loading')
    })
}
// Returns the E.164 number to text, null when the shopper did not opt in, or false when they
// ticked the box without a valid US/CA mobile number (error shown, submit stopped).
function readSmsOptIn() {
    const consent = document.getElementById('prex-bis-sms-consent')
    if (!consent) {
        return null
    }
    const control = consent.closest('.prex-bis-sms')
    const msgEle = control.querySelector('.gBackInStock-messages')
    const phoneEle = document.getElementById('prex-bis-sms-phone')
    control.classList.remove('has-error')
    msgEle.classList.remove('gBackInStock-messages-error')
    msgEle.innerHTML = ''
    if (!consent.checked) {
        return null
    }
    const phone = toE164NorthAmerica(phoneEle.value)
    if (!phone) {
        control.classList.add('has-error')
        msgEle.classList.add('gBackInStock-messages-error')
        msgEle.innerHTML = 'Please enter a valid US or Canadian mobile number'
        phoneEle.focus()
        return false
    }
    return phone
}
// US and Canada share +1 (NANP): 10 digits, area code and exchange start with 2-9.
function toE164NorthAmerica(raw) {
    let digits = String(raw || '').replace(/\D/g, '')
    if (digits.length === 11 && digits.charAt(0) === '1') {
        digits = digits.slice(1)
    }
    if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) {
        return null
    }
    return '+1' + digits
}
// Klaviyo client Subscribe Profiles: SMS marketing only (the email consent is left alone), into
// the double opt-in list Syw9UJ, so Klaviyo texts "reply YES" before anything else is sent.
// The email identifies the same profile the back-in-stock event (UgJE8C) lands on.
// Revision must be 2025-01-15 or later: older ones reject profile.subscriptions (400).
function subscribeSms(email, phone) {
    const body = {
        data: {
            type: 'subscription',
            attributes: {
                custom_source: 'Back in stock popup',
                profile: {
                    data: {
                        type: 'profile',
                        attributes: {
                            email: email,
                            phone_number: phone,
                            subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
                        }
                    }
                }
            },
            relationships: { list: { data: { type: 'list', id: 'Syw9UJ' } } }
        }
    }
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=RUTRfK', {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' },
        body: JSON.stringify(body)
    }).then(response => {
        showSmsResult(response.ok)
    }).catch(() => {
        showSmsResult(false)
    })
}
function showSmsResult(ok) {
    const popup = document.getElementById('Globo-Back-In-Stock-Popup')
    if (!popup) {
        return
    }
    const footer = popup.querySelector('.Globo-body-footer')
    // Own class, not .gBackInStock-Form-Message: the email result handler removes that one.
    const old = footer.querySelector('.prex-bis-sms-result')
    if (old) {
        old.remove()
    }
    const text = ok
        ? 'Check your phone: reply YES to the text from P-Rex Hobby to confirm restock texts.'
        : 'We couldn&rsquo;t sign up your number for texts. Your email sign-up is not affected.'
    footer.insertAdjacentHTML('beforeend', `<div class="prex-bis-sms-result">
            <p class="gBackInStock-Message ${ok ? 'gBackInStock-Message-Success' : 'gBackInStock-Message-Error'}">${text}</p>
        </div>`)
}
function validateEmail(email) {
    return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email)
}

// ============================================================================
// Hover overlay ATC click delegate
//   Restored 2026-05-10 after PR #10 (Pipeline B retirement) inadvertently
//   removed it along with snippets/product-list.liquid. The hover overlay
//   in product-card.liquid renders <button type="button" class="custom-hover-trigger"
//   data-target-form="product_form_<id>"> — clicking it should submit the
//   matching <product-form> elsewhere on the page.
// ============================================================================
function hoverTriggerDelegate() {
    document.addEventListener('click', function(e) {
        var trigger = e.target.closest('.custom-hover-trigger');
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        var formId = trigger.getAttribute('data-target-form');
        if (!formId) return;
        var form = document.getElementById(formId);
        if (!form) return;
        var realButton = form.querySelector('button[type="submit"]');
        if (realButton) {
            realButton.click();
            return;
        }
        form.submit();
    });
}
hoverTriggerDelegate();

if (!customElements.get('x-dropdown')) {
    class Dropdown extends HTMLElement {
        constructor() {
            super()
            this.details = null
            this.summary = null
            this.menu = null
            this.labelNode = null
            this.onSummaryClick = this.onSummaryClick.bind(this)
            this.onDocumentClick = this.onDocumentClick.bind(this)
            this.onItemActivate = this.onItemActivate.bind(this)
        }
        connectedCallback() {
            this.details = this.querySelector('details')
            this.summary = this.querySelector('summary')
            this.menu = this.querySelector('.facets__display')
            this.labelNode = this.querySelector('.sorting-label-current')
            if (!this.details || !this.summary || !this.menu) return

            // Ensure initial ARIA state
            this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false')

            // Events
            this.summary.addEventListener('click', this.onSummaryClick)
            document.addEventListener('click', this.onDocumentClick)
            this.menu.addEventListener('click', this.onItemActivate)

            // Initialize selected state/label
            this.initializeSelectionFromDom()
        }
        disconnectedCallback() {
            if (this.summary) this.summary.removeEventListener('click', this.onSummaryClick)
            document.removeEventListener('click', this.onDocumentClick)
            if (this.menu) this.menu.removeEventListener('click', this.onItemActivate)
        }
        open() {
            if (!this.summary) return
            this.setAttribute('open', '')
            this.summary.setAttribute('aria-expanded', 'true')
            if (this.details) this.details.setAttribute('open', '')
        }
        close() {
            if (!this.summary) return
            this.removeAttribute('open')
            this.summary.setAttribute('aria-expanded', 'false')
            if (this.details) this.details.removeAttribute('open')
        }
        toggle() {
            if (this.hasAttribute('open')) {
                this.close()
            } else {
                // Close other open dropdowns on the page
                document.querySelectorAll('x-dropdown[open]').forEach((el) => {
                    if (el !== this && typeof el.close === 'function') el.close()
                })
                this.open()
            }
        }
        onSummaryClick(event) {
            event.preventDefault()
            this.toggle()
        }
        onDocumentClick(event) {
            if (!this.hasAttribute('open')) return
            const target = event.target
            if (!(target instanceof Node)) return
            if (!this.contains(target)) {
                this.close()
            }
        }
        initializeSelectionFromDom() {
            // Prefer URL state if available (page refresh / deep link)
            try {
                const url = new URL(window.location.href)
                const sortBy = url.searchParams.get('sort_by')
                if (sortBy) {
                    const urlInput = this.querySelector(`.facets__display input.radio[value="${sortBy}"]`)
                    if (urlInput) {
                        urlInput.checked = true
                        this.applySelectionFromInput(urlInput, { closeAfter: false, emit: false })
                        return
                    }
                }
            } catch (e) {}

            // Fallback to server-rendered checked state
            const checkedInput = this.querySelector('.facets__display input.radio:checked')
            if (checkedInput) {
                this.applySelectionFromInput(checkedInput, { closeAfter: false, emit: false })
                return
            }
            const checkedItem = this.querySelector('.facets__display .facets__item.checked input.radio')
            if (checkedItem) {
                this.applySelectionFromInput(checkedItem, { closeAfter: false, emit: false })
            }
        }
        onItemActivate(event) {
            const input = event.target.closest('input.radio')
            const label = event.target.closest('label')
            if (!input && !label) return
            const targetInput = input || (label && label.querySelector('input.radio'))
            if (!targetInput) return
            event.stopPropagation()
            this.applySelectionFromInput(targetInput, { closeAfter: true, emit: true })
        }
        applySelectionFromInput(input, { closeAfter = true, emit = true } = {}) {
            // Update radio state
            const allInputs = this.querySelectorAll('.facets__display input.radio')
            allInputs.forEach(i => { i.checked = (i === input) })

            // Update checked classes
            const items = this.querySelectorAll('.facets__display .facets__item')
            items.forEach(li => li.classList.remove('checked'))
            const li = input.closest('.facets__item')
            if (li) li.classList.add('checked')

            // Update summary label
            const labelTextEl = li && li.querySelector('.sort-label-text')
            if (this.labelNode && labelTextEl) {
                this.labelNode.textContent = labelTextEl.textContent.trim()
            }

            // Emit change so external code can hook if needed
            if (emit) {
                const changeEvent = new Event('change', { bubbles: true })
                input.dispatchEvent(changeEvent)
            }

            // Close after selecting
            if (closeAfter) this.close()
        }
    }
    customElements.define('x-dropdown', Dropdown)
}

if (!customElements.get('collection-bar')) {
    class CollectionBar extends HTMLElement {
        constructor() {
            super()
            this.onClick = this.onClick.bind(this)
            this.onKey = this.onKey.bind(this)
            this.onChange = this.onChange.bind(this)
        }
        connectedCallback() {
            this.addEventListener('click', this.onClick)
            this.addEventListener('keydown', this.onKey)
            this.addEventListener('change', this.onChange)
        }
        disconnectedCallback() {
            this.removeEventListener('click', this.onClick)
            this.removeEventListener('keydown', this.onKey)
            this.removeEventListener('change', this.onChange)
        }
        onClick(event) {
            const toggle = event.target.closest('.collection-checkbox')
            if (!toggle || !this.contains(toggle)) return
            event.preventDefault()
            this.toggleCheckbox(toggle)
            const key = toggle.getAttribute('data-key')
            if (key === 'show-preorders' || key === 'show-out-of-stock') {
                this.applyAvailFilters(toggle)
            }
        }
        onChange(event) {
            const input = event.target.closest('input[name="sort_by"]')
            if (!input || !this.contains(input)) return
            this.updateSort(input.value)
        }
        updateSort(value) {
            const url = new URL(window.location.href)
            url.searchParams.set('sort_by', value)
            url.searchParams.delete('page')
            const sectionNode = this.querySelector('[section-id]')
            if (sectionNode) {
                url.searchParams.set('section_id', sectionNode.getAttribute('section-id'))
            }
            this.dispatchEvent(new CustomEvent('facet:update', {
                bubbles: true,
                detail: { url }
            }))
        }
        onKey(event) {
            if (event.key === ' ' || event.key === 'Enter') {
                const active = document.activeElement
                if (active && active.classList && active.classList.contains('collection-checkbox') && this.contains(active)) {
                    event.preventDefault()
                    this.toggleCheckbox(active)
                }
            }
        }
        toggleCheckbox(node) {
            const isChecked = node.getAttribute('aria-checked') === 'true'
            node.setAttribute('aria-checked', isChecked ? 'false' : 'true')
            node.classList.toggle('checked', !isChecked)
            // Optionally emit custom event for external filters
            const key = node.getAttribute('data-key')
            this.dispatchEvent(new CustomEvent('collection-bar:toggle', {
                bubbles: true,
                detail: { key, checked: !isChecked }
            }))
           
        }
        applyAvailFilters(node) {
            // 2026-07-06 SEMANTICS: the DEFAULT state shows everything orderable --
            // In Stock / Back Order(s) / active pre-orders -- and hides only
            // Out of Stock + Pre-Order Closed. "Hide pre-orders" is opt-OUT,
            // "Show out of stock" is opt-IN. The default keep-list is applied
            // pre-paint by snippets/collection-default-avail.liquid (in-place
            // section swap); this handler owns every state change after that.
            // The Shopify metafield facet (filter.p.m.custom.product_avail) is allow-list
            // only -- you append the values you want to KEEP. Canonical strings mirror
            // prexhobby-spider constant.py; keep in sync if a new product_avail value is
            // introduced (an unknown value is visible ONLY in the show-all state).
            //   ALWAYS_AVAILABLE : orderable now (In Stock) or via deposit (Back Order) -> never hidden
            //   PREORDER_ACTIVE  : still-orderable pre-orders -> shown unless "Hide pre-orders"
            //   OUT_OF_STOCK     : not orderable -> hidden unless "Show out of stock"
            //   "Pre-Order Closed" is a pre-order AND not orderable -> visible only in show-all
            //   (except collection-bar[data-closed-preorder-default], see below).
            // Keep-list per toggle state:
            //   neither checked      -> ALWAYS_AVAILABLE + PREORDER_ACTIVE (the default)
            //   Hide PO only         -> ALWAYS_AVAILABLE
            //   Show OOS only        -> no filter at all, marked with ?avail=all so the head
            //                           script does not re-apply the default keep-list
            //                           (this is the only state surfacing "Pre-Order Closed").
            //   Hide PO + Show OOS   -> ALWAYS_AVAILABLE + OUT_OF_STOCK.
            //   "Waitlist" (P-Bandai demand-test, never purchasable) is OUT_OF_STOCK,
            //   except on its landing collection (collection-bar[data-waitlist-default])
            //   where it rides with PREORDER_ACTIVE (2026-09-24).
            const ALWAYS_AVAILABLE = ["In Stock", "Back Order", "Back Orders"]
            const PREORDER_ACTIVE = ["Pre-Order", "Pre-Order Subscription"]
            const OUT_OF_STOCK = ["Out of Stock"]
            if (this.hasAttribute('data-waitlist-default')) PREORDER_ACTIVE.push("Waitlist")
            else OUT_OF_STOCK.push("Waitlist")
            // 2026-10-08: on collections flagged custom.default_show_closed_preorders (bandai),
            // "Pre-Order Closed" rides with the pre-orders instead of being show-all only.
            if (this.hasAttribute('data-closed-preorder-default')) PREORDER_ACTIVE.push("Pre-Order Closed")

            // 2026-09-25 (CRO #7b): the toggle is "Show pre-orders" now (checked = pre-orders on the
            // page), matching "Show out of stock". Internally we still reason in hidePreorders.
            const showPreordersNode = this.querySelector('.collection-checkbox[data-key="show-preorders"]')
            const showOOSNode = this.querySelector('.collection-checkbox[data-key="show-out-of-stock"]')
            const hidePreorders = !!showPreordersNode && showPreordersNode.getAttribute('aria-checked') !== 'true'
            const showOOS = showOOSNode && showOOSNode.getAttribute('aria-checked') === 'true'

            const url = new URL(window.location.href)
            url.searchParams.delete("filter.p.m.custom.product_avail")
            url.searchParams.delete("avail")
            url.searchParams.delete("page")

            if (!hidePreorders && showOOS) {
                url.searchParams.set("avail", "all")
            } else {
                let values = ALWAYS_AVAILABLE.slice()
                if (!hidePreorders) values = values.concat(PREORDER_ACTIVE)
                if (showOOS) values = values.concat(OUT_OF_STOCK)
                values.forEach((value) => {
                    url.searchParams.append("filter.p.m.custom.product_avail", value)
                })
            }

            url.searchParams.set("section_id", node.getAttribute("section-id"))
            this.dispatchEvent(new CustomEvent("facet:update", {
                bubbles: true,
                detail: { url }
            }))
        }
    }
    customElements.define('collection-bar', CollectionBar)
}

